<template>
  <v-row align="center" justify="center" class="row">
    <v-col align="center">
      <p class="text-h5 mt-3 text-center">システム利用申し込み</p>
      <p class="env-text">ブラウザは、WindowsはEdgeまたはChrome、MacはSafariをご利用ください</p>
      <v-card height="400px" max-width="471px" class="mt-3 pa-6 pt-1 elevation-10">
        <v-card-text class="text-center card-text">
          <v-form ref="form" @submit.prevent>
            <p class="error-messages mb-0">{{messages}}</p>
            <v-text-field
              class="mt-1 mb-3"
              label="お客様No."
              v-model="clientCode"
              type="text"
              color="secondary"
              outlined
              hide-details
              dense
            ></v-text-field>
            <v-btn
              rounded
              block
              color="secondary"
              :disabled="!clientCode"
              class="search-btn mb-6"
              @click.stop="checkClientCode"
              type="submit"
            >お客様No.を照合</v-btn>
          </v-form>
          <p>「お客様No.」とは、9桁の数字となります。<br>確認方法は<a class="pdf-link" @click="showPDF" >こちら</a>をご覧ください。</p>
        </v-card-text>

        <div class="attention text-left">
          <p>※お客様No.は、弊社営業所または弊社特約店から教材購入時に使用している番号をご入力ください。</p>
          <p>
            セキュリティ強化のため、照合ボタンをクリックしてから30分を過ぎるとエラーになります。（タイムアウト）<br>
            お手数をおかけしますが、再度お客様No.を入力し、照合をお願いいたします。
          </p>
        </div>

      </v-card>
    </v-col>
  </v-row>
</template>

<script>

export default {
  components: {
  },
  props: {
    source: String,
  },
  data() {
    return {
      clientCode: '',
      messages: ''
    }
  },
  mounted() {
    // sessionに入ってる情報を破棄
    sessionStorage.removeItem('ENGetThrough')
    // ログイン中と判断される値を初期化
    this.$store.commit('user/logout', {})
  },
  methods: {
    showPDF() {
      window.open('https://www.en-plat.jp/%E3%81%8A%E5%AE%A2%E6%A7%98CD%E7%A2%BA%E8%AA%8D%E7%94%A8.pdf')
    },
    async checkClientCode() {
      const res = await this.$axios.post('/api/v1/enrollment/search_client_code', {
        client_code: this.clientCode,
      })
      this.messages = res.data.messages
      if (this.messages === '') {
        // 認証情報とログイン情報をstoreに格納
        this.$store.commit('enrollment/setClientCode', { clientCode: this.clientCode})
        this.$store.commit('enrollment/setLastOperatedDate', { lastOperatedDate: new Date })
        this.$store.commit('user/setRole', { role: 'enrollment' })
        // 規約画面へ遷移
        this.$router.push('/enrollment/terms_of_service')
      }
    }
  }
}
</script>

<style lang="stylus">
.v-input__slot
  min-height 40px !important
  margin-bottom 4px !important
.v-text-field__details
  background-color white !important
  margin-bottom 8px !important
  padding 0px 12px !important
</style>

<style lang="stylus" scoped>
.row
  height 100%

.logo-area
  position relative
  margin-bottom 90px

.logo
  position absolute
  left 24%

.background
  background-image: linear-gradient(to bottom, #335e8d, #4a8cae 30%, #2b638d);

.search-btn
  color white !important

.pdf-link
  color #3e63d0

.card-text
  width 80%

.env-text
  font-size 13px
  color #646464

.attention
  font-size 12px
  color black

.error-messages
  height 50px
  color red


button:enabled
  background-image linear-gradient(to bottom, #10318b, #55669b 30%, #2b3555)

</style>
